import React, { Component } from "react";
import {
  Grid,
  Icon,
  Header,
  Input,
  Button,
  Divider,
  Label,
  Form
} from "semantic-ui-react";
import moment from "moment";
// import InvoiceTable from "./invoicetable";
class CreateInv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startdate: null,
      enddate: null
    };
  }
  gencreatebutton() {
    if (this.state.startdate && this.state.enddate) {
      return (
        <Button
          color="green"
          id="createinvbtn"
          onClick={() => {
            this.props.createInv();
          }}
        >
          Create Invoices <Icon name="check" />
        </Button>
      );
    }
  }
  HandleRuninvoices(startdate, enddate) {
    console.log("attempting invoices");
    console.log("start date is " + startdate);
    console.log("end date is " + enddate);
    if (startdate && enddate) {
      this.props.runinvoices(this.state.startdate, this.state.enddate);
    }
  }
  gentable() {
    if (this.props.newinvoices && this.props.newinvoices.length === 0) {
      return <Header size="large"> Nothing to Invoice for this period </Header>;
    } else if (!this.props.invoices) {
      return (
        <Header size="large">
          Select start and end date to run custom invoices on.{" "}
        </Header>
      );
    }
  }

  render() {
    return (
      <div className="CreateInv">
        <Grid>
          <Grid.Column width={10}>
            <Form>
              <Form.Group>
                <Form.Field>
                  <Label> Set Start Date for Custom Invoice </Label>{" "}
                  <Input
                    type="date"
                    placeholder="MM/DD/YYYY"
                    value={this.state.startdate}
                    onChange={e => {
                      let newdate = moment(e.target.value).format("YYYY-MM-DD");
                      this.setState({
                        startdate: newdate
                      });
                      this.HandleRuninvoices(newdate, this.state.enddate);
                    }}
                  />{" "}
                </Form.Field>{" "}
                <Form.Field>
                  <Label> Set End Date for Custom Invoice </Label>{" "}
                  <Input
                    type="date"
                    placeholder="MM/DD/YYYY"
                    value={this.state.enddate}
                    onChange={e => {
                      let newdate = moment(e.target.value).format("YYYY-MM-DD");
                      console.log(newdate);
                      this.setState({
                        enddate: newdate
                      });
                      this.HandleRuninvoices(this.state.startdate, newdate);
                    }}
                  />{" "}
                </Form.Field>{" "}
                <Form.Field> {this.gencreatebutton()} </Form.Field>{" "}
              </Form.Group>{" "}
            </Form>{" "}
          </Grid.Column>{" "}
        </Grid>{" "}
        <Divider /> {this.gentable()}{" "}
      </div>
    );
  }
}
export default CreateInv;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/custominv.js